export default __webpack_public_path__ + "static/media/pf.dbe7addd.svg";